import axios, { AxiosInstance } from 'axios'

const api = axios.create({
    baseURL: '/',
    withCredentials: true,
})

api.interceptors.request.use(
    (config) => {
        return {
            ...config,
        }
    },
    (error) => Promise.reject(error)
)


export const get: AxiosInstance['get'] = api.get
export const post: AxiosInstance['post'] = api.post
export const put: AxiosInstance['put'] = api.put
export const destroy: AxiosInstance['delete'] = api.delete
